module.exports = __webpack_public_path__ + "media/newstyle/images/visa-6a016e41b917b8fe5e689dc5c923e880.svg";